import react, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useLanguage } from "./LanguageContext";
import SelectWhatsappModal from "./SelectWhatsappModal";
import { useParams } from "react-router-dom";

const Header = (props) => {

    const [navOpen, setNavOpen] = useState(false);

    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useOutletContext(false);
    const [showSelectWhatsappModal, setShowSelectWhatsappModal] = useState(false);

    const { language, changeLanguage } = useLanguage();

    const [ showBackToPickGuide, setShowBackToPickGuide ] = useState(false);

    const handleLogoClick = () => {
        window.open("/", "_self");
    }

    const { p } = useParams();

    const handleClickAbout = () => {
      setNavOpen(false);
      if(showBackToPickGuide) {
        let e_ph = window.localStorage.getItem("p") || p;
        navigate("/guide/pick-guide/"+e_ph, "_self");
        return;
      } else {
        window.open("https://guides.theboggler.com/signup/influencer", "_self");
        return;
      }
    }
    
    const handleAccountClick = () => {
      setNavOpen(false);
      if(props.accountClick) {
        props.accountClick();
      }
      navigate("/choose-account", "_self");
    }

    const handleLogoutClick = () => {
      setNavOpen(false);
      props.handleLogout();
      window.localStorage.removeItem("sessionToken");
      window.localStorage.removeItem("sessionExpiry");
    }

    useEffect(() => {
        if(window.localStorage.getItem("p") || p) {
            let e_ph = window.localStorage.getItem("p") || p;
            if(e_ph.length > 5) {
                setShowBackToPickGuide(true);
            }
        }
        if(window.location?.pathname?.includes("/pay/")
            && window.location?.pathname?.includes("guide-intro-call")) {
            setShowBackToPickGuide(true);
        }
    }, []);

    return (
        <header className="mobile-header">
            <SelectWhatsappModal show={showSelectWhatsappModal} onClose={() => setShowSelectWhatsappModal(false)} phoneNumber="+94741302208" />
            <div className="header-logo-wrapper">
                <img
                    onClick={handleLogoClick}
                    src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.webp"
                    alt="Boggler Logo"
                    className="header-logo"
                    loading="lazy"
                    style={{ borderRadius: 35, cursor: "pointer" }}
                />
            <button
                className={`hamburger${navOpen ? ' open' : ''}`}
                aria-label="Open navigation"
                onClick={() => setNavOpen(!navOpen)}
            >
                <span className="bar" />
                <span className="bar" />
                <span className="bar" />
            </button>
            </div>
            <nav className={`main-nav${navOpen ? " open" : " closed"}`}>
                <span className="header-button" onClick={handleClickAbout}>{showBackToPickGuide ? "Pick Guide" : "About"}</span>
                <span className="header-button" onClick={() => { showBackToPickGuide ? window.open("https://guides.theboggler.com/signup/influencer", "_self") : window.open("/pick-guide", "_self") }}>{showBackToPickGuide ? "About" : "Pick Guide"}</span>
                {/* <span className="header-button" onClick={() => { window.open("https://guides.theboggler.com/boggler-trails", "_self") }}>Boggler Trails</span> */}
                {/* <span className="header-button header-button-contact" onClick={() => navigate("/fairygodmother/signup", "_self")}>Fairy Godmother</span>
                <span className="header-button header-button-contact" onClick={() => window.open("https://guides.theboggler.com", "_self")}>Guides</span> */}
                <span className="header-button" onClick={handleAccountClick}>Account</span>
                {props?.page === "account" && props?.isLoggedIn && (
                  <span className="header-button" onClick={handleLogoutClick}>Logout</span>
                )}
                {/* <span className="header-button header-button-sinhala sinhala-button" 
                    onClick={() => {
                        setLanguage(language === "sinhala" ? "english" : "sinhala")
                        changeLanguage(language === "sinhala" ? "english" : "sinhala");
                    }}
                >{language === "english" ? "සිංහල" : "English?"}</span> */}
            </nav>
        </header>
    )
}

export default Header;